/** Which backend to use for grammar/spelling evaluation on essay-type tasks. */
export const grammarEvaluationBackend: 'languagetool' | 'llm' | 'languagetool+llm' = 'llm';
